import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { diagnosticType } from '../types/server'
import {
  DiagnosticCollectionMutationArgs,
  diagnosticCollectionMutationArgs
} from '../types/server-settings-args'
import { updateDiagnosticCollection } from '../queries/helpers/server'
import { DiagnosticCollectionSettings } from '../../../components/servers-grid/shared'

export const updateDiagnosticCollectionSettings: GraphQLFieldConfig<
  any,
  Context,
  DiagnosticCollectionMutationArgs
> = {
  description: "Update a server's diagnostic collection settings",
  type: new GraphQLNonNull(diagnosticType),
  args: diagnosticCollectionMutationArgs,
  resolve: async (
    _source,
    args,
    context: Context
  ): Promise<DiagnosticCollectionSettings> => {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }
    const {
      id,
      organizationID,
      diagnosticCollection: { enabled, logLevel, duration }
    } = input

    const { connector } = context
    await Promise.all([
      connector.put(
        `/organizations/${organizationID}/servers/${id}/diagnostic`,
        {
          enabled,
          log_level: logLevel,
          duration
        }
      )
    ])

    return updateDiagnosticCollection(id, organizationID, connector)
  }
}
